export default __webpack_public_path__ + "static/Bild-81ac70d47d64e292a8a942e0573c87b5.svg";